// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ 
  children, 
  requiredRoles = ['production', 'manager', 'admin'] 
}) => {
  // Récupérer le type d'utilisateur depuis le localStorage
  const userType = localStorage.getItem('userType');
  
  // Si aucun utilisateur n'est connecté, rediriger vers la page de connexion
  if (!userType) {
    return <Navigate to="/login" replace />;
  }
  
  // Vérifier si le type d'utilisateur est autorisé à accéder à cette route
  if (requiredRoles.includes(userType)) {
    // Si oui, rendre le composant enfant
    return children;
  } else {
    // Sinon, rediriger vers la page d'accueil ou une page d'erreur
    return <Navigate to="/" replace />;
  }
};

export default ProtectedRoute;